// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewChecked, Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavService } from '@services/nav.service';
import { takeWhile } from 'rxjs';

@Component({
    selector: 'app-pddj',
    templateUrl: './pddj.component.html',
    styleUrls: ['./pddj.component.scss'],
})
export class PddjComponent implements AfterViewChecked {
    isLoggedIn = false;
    private isComponentAlive = true;

    constructor(
        private readonly navService: NavService,
        private readonly router: Router
    ) {
        this.router.events.pipe(takeWhile(() => this.isComponentAlive)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                event.url.includes('login') ? (this.isLoggedIn = false) : (this.isLoggedIn = true);
            }
        });
    }

    ngAfterViewChecked(): void {
        this.setDisplay();
    }

    @HostListener('window:resize')
    onResize() {
        this.setDisplay();
    }

    private setDisplay(): void {
        // const targetEl = document.querySelector('#scroll') as HTMLElement;
        //     targetEl.classList.remove('mobile-without-breadcrumbs');
        //     targetEl.classList.remove('mobile-with-breadcrumbs');
        //     targetEl.classList.remove('desktop-with-breadcrumbs');
        //     targetEl.classList.remove('desktop-without-breadcrumbs');
        //     targetEl.style.height = 'auto';
    }
}
